
export const COOKIE_MODE = 'small'; // simple / extended / small

export const COOKIE_NAMES_PRIVACY_POLICY = 'cookies_accepted';

export const ANALITICS_COOKIES = [
    '_gat_UA-%', '_ga', '_ga_%', '_gali', '_gid',
    '_gat',
    'ccx_uid', 'smcfds', 'smvr', 'smuuid', 'smwp',
    'visitor-id', 'CMTS', 'data-c'
];

export const MARKETING_COOKIES = [
    '__ar_d_id', '__ar_si', '__ar_v_id',
    '1P_JAR', 'CCMSESSID', 'DSID', 'IDE', 'NID', 'OTZ', '_gcl_au', 'ccxid',
    '_fbp',
    '_pin_unauth', '_pinterest_ct_ua',
    '_uetsid','_uetvid',
    'twdSPT',
    '_ttp', '_tt_enable_cookie',
    'uuid2', 'criteo', 'tuuid_lu', 'IDSYNC', '_uetsid', 'cnac', '_kuid_', 'MUID',
    'dpm', 'bscookie', 'tuuid', 'bcookie', '_gcl_au', 'datr', '_clck', 'data-c-ts',
    'UserMatchHistory', 'car', 'umeh', 'A3'
];

export const FUNCTIONAL_COOKIES = [
    'DV', 'HSID', 'OGP', 'OGPC', '_dc_gtm_UA-%',
    'am_tokens_eu-v1', 'mv_tokens', 'igodigitalst_%', 'am_tokens',
    'igodigitaltc2', 'igodigitalstdomain', '_hjid', '_hjSesjaUser_%', 'gdpr', '_hjSesja_%',
    '_hjIncludedInSesjaSample', 'li_gc', '_hjAbsoluteSesjaInProgress', 'AnalyticsSyncHistory',
    '_hjFirstSeen'
];

export const COOKIES_SETTINGS_NAME = 'COOKIES_SETTINGS';

export const COOKIES_SETTINGS = {
    'analytics': true,
    'marketing': true,
    'functional': true
};
